import * as React from 'react';
import { Component } from 'react';
import { SearchService } from '../../services/SearchService';
import { IPlace } from '../../models/IPlace';


interface IProps {
    Value?: IPlace,
    DefaultCities: IPlace[],
    OnSelectedPlace: (place: IPlace) => void,
    OnPlaceDetailsReceived: (place: IPlace) => void,
    AddPlaceDetails?: boolean;
    Placeholder?: string;
}

interface IState {
    PlaceDropDownOpen: boolean,
    Place?: string,
    SelectedPlace?: IPlace,
    Places: IPlace[],
    LoaderVisible: boolean,
    InputHighlighted: boolean,
    HighLightedIndex: number
}

export class PlaceSearch extends Component<IProps, IState> {

    private dataRefreshTimeout: any;
    private autocompletePlaceService = null;
    private defaultCities: IPlace[];
    private sessionToken = null;
    private dummyRefForGooglePlaceService = React.createRef<HTMLDivElement>();
    private apiReadyId: number = 0;
    private placeDropDownContainerNode: Node | null;
    private selectedPlaceFromList?: IPlace;

    constructor(props) {
        super(props);

        this.state = {
            Place: this.props.Value ? this.props.Value.name : undefined,
            PlaceDropDownOpen: false,
            Places: this.props.DefaultCities,
            SelectedPlace: this.props.Value,
            LoaderVisible: false,
            InputHighlighted: false,
            HighLightedIndex: -1
        }

        this.defaultCities = this.props.DefaultCities;

        this.OpenPlaceDropDown = this.OpenPlaceDropDown.bind(this);
        this.ClosePlaceDropDown = this.ClosePlaceDropDown.bind(this);
        this.OnGetPlacesSuccess = this.OnGetPlacesSuccess.bind(this);
        this.OnGetPlacesError = this.OnGetPlacesError.bind(this);
        this.OnChange = this.OnChange.bind(this);
        this.HandleClickOutside = this.HandleClickOutside.bind(this);
        this.OnInputKeyPress = this.OnInputKeyPress.bind(this);
        this.OnPlaceClick = this.OnPlaceClick.bind(this);
        this.GetPlaceDetails_GetSelectedPlace = this.GetPlaceDetails_GetSelectedPlace.bind(this);
        this.InitPredictionsTimeout = this.InitPredictionsTimeout.bind(this);

        this.GetDefaultPlaces();
    }

    public componentWillMount() {
        document.addEventListener('click', this.HandleClickOutside, false);
    }

    public componentWillUnmount() {
        document.removeEventListener('click', this.HandleClickOutside, false);
        (window as any).DeregisterGoogleApiReady(this.apiReadyId);
    }

    public componentDidMount() {
        if ((window as any).google === undefined) {
            this.apiReadyId = (window as any).RegisterGoogleApiReady(this.InitAutocompleteService.bind(this));
        }
        else {
            this.InitAutocompleteService();
        }
    }

    public componentWillReceiveProps(nextProps: IProps) {
        if (this.state.Place === undefined) {
            this.setState({
                Place: nextProps.Value ? nextProps.Value.name : undefined,
                SelectedPlace: nextProps.Value ? nextProps.Value : undefined
            });
        } else {
            if (nextProps.Value) {
                if (this.state.Place !== nextProps.Value.name) {
                    this.setState({
                        Place: nextProps.Value ? nextProps.Value.name : undefined,
                        SelectedPlace: nextProps.Value ? nextProps.Value : undefined
                    });
                }
            }
        }
    }

    public render() {
        return (
            <form>
                <div className={'select-container' + (this.state.InputHighlighted ? ' highlighted' : '')}
                    tabIndex={-1}
                    ref={node => this.placeDropDownContainerNode = node}>
                    <input type="text"
                        autoComplete="off"
                        name="Place"
                        className="form-control"
                        value={this.state.Place ? this.state.Place : ''}
                        placeholder={this.props.Placeholder ? this.props.Placeholder : "Miejscowość"}
                        onFocus={this.OpenPlaceDropDown}
                        onBlur={this.ClosePlaceDropDown}
                        onChange={this.OnChange}
                        onKeyDown={this.OnInputKeyPress} />
                    {this.RenderPlaceDropDown()}
                    <div ref={this.dummyRefForGooglePlaceService} />
                    <input type="hidden" autoComplete="hidden-autocomplete-fix" />
                </div>
            </form>
        );
    }

    public OpenDropDown() {
        this.setState({
            PlaceDropDownOpen: true,
            InputHighlighted: true
        });
    }

    public GetSelectedPlace(): IPlace | undefined {
        if (this.state.SelectedPlace !== undefined) {
            return this.state.SelectedPlace;
        } else {
            if (this.state.PlaceDropDownOpen) {
                if (this.state.Places.length > 0) {
                    this.GetPlaceDetails_GetSelectedPlace(this.state.Places[0]);
                    return undefined;
                } else {
                    return undefined;
                }
            } else {
                return undefined;
            }
        }
    }

    public GetInputValue(): string {
        return this.state.Place ? this.state.Place : '';
    }

    private InitAutocompleteService() {
        this.autocompletePlaceService = new (window as any).google.maps.places.AutocompleteService();
        this.sessionToken = new (window as any).google.maps.places.AutocompleteSessionToken();
    }

    private OpenPlaceDropDown(e) {
        this.setState({
            PlaceDropDownOpen: true
        });
    }

    private ClosePlaceDropDown(e) {
        setTimeout((t) => {
            t.setState({
                PlaceDropDownOpen: false
            });
        }, 250, this);
    }

    private DisplaySugesstions(predictions, status) {

        let places: IPlace[] = [];
        if (status === "OK") {

            predictions.map((p, idx) => (
                places.push({ name: p.description, administrativeArea: "", useOnlyViewportForSearch: false, id: p.place_id, place_id: p.place_id, location: undefined, viewport: undefined })
            ));
        }

        this.setState({
            Places: places,
            LoaderVisible: false
        });
    }

    private OnChange(event) {

        const value: string = event.target.value;
        let places: IPlace[] = [];
        let loaderVisible = false;

        let showDropDown: boolean = false;
        if (value.length === 0) {
            showDropDown = true;
            places = this.defaultCities;
        } else if (value.length > 0) {
            showDropDown = true;

            let tmp = false;
            if (tmp) {
                let request = {
                    input: value,
                    sessionToken: this.sessionToken,
                    componentRestrictions: { country: 'pl' },
                    types: ['geocode']
                };
                (this.autocompletePlaceService as any).getPlacePredictions(request, this.DisplaySugesstions.bind(this));
            } else {
                this.InitPredictionsTimeout(value);
            }

            loaderVisible = true;
        } else {
            showDropDown = false;
        }

        this.setState({
            PlaceDropDownOpen: showDropDown,
            Places: places,
            Place: value,
            LoaderVisible: loaderVisible,
            SelectedPlace: undefined
        });

    }

    private InitPredictionsTimeout(value) {
        if (this.dataRefreshTimeout) {
            clearTimeout(this.dataRefreshTimeout);
            this.dataRefreshTimeout = undefined;
        }
        this.dataRefreshTimeout = setTimeout((t, v) => {
            let request = {
                input: v,
                sessionToken: t.sessionToken,
                componentRestrictions: { country: 'pl' },
                types: ['geocode']
            };
            t.autocompletePlaceService.getPlacePredictions(request, t.DisplaySugesstions.bind(t));

            clearTimeout(t.dataRefreshTimeout);
        }, 350, this, value);
    }

    private PlaceDetailsCallback(
        place: google.maps.places.PlaceResult,
        status: google.maps.places.PlacesServiceStatus
    ) {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
            if (place.geometry !== undefined && this.state.SelectedPlace !== undefined) {
                let selectedPlace: IPlace = this.state.SelectedPlace;
                selectedPlace.location = {
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng()
                };

                if (place.geometry.viewport) {
                    let viewport = place.geometry.viewport;
                    selectedPlace.viewport = {
                        northeast: { lat: viewport.getNorthEast().lat(), lng: viewport.getNorthEast().lng() },
                        southwest: { lat: viewport.getSouthWest().lat(), lng: viewport.getSouthWest().lng() }
                    }
                    selectedPlace.useOnlyViewportForSearch = false;
                }
                if (place.address_components) {
                    const zipCode = place.address_components.find(item => item.types.includes("postal_code"));
                    const street = place.address_components.find(item => item.types.includes("route"));
                    const city = place.address_components.find(item => item.types.includes("locality"));
                    selectedPlace.address = {
                        Street: street ? street.long_name : "",
                        ZipCode: zipCode ? zipCode.long_name : "",
                        City: city ? city.long_name : ""
                    }
                }


                this.setState({
                    SelectedPlace: selectedPlace
                });
                this.props.OnSelectedPlace(selectedPlace);
            }
        } else {
            if (this.props.AddPlaceDetails && this.state.SelectedPlace) {
                this.props.OnSelectedPlace(this.state.SelectedPlace);
            }
        }
    }

    private OnPlaceClick(place: IPlace) {
        this.setState({
            Place: place.name,
            SelectedPlace: place,
            InputHighlighted: false,
            PlaceDropDownOpen: false
        }, () => {
            if (place.place_id != null || this.props.AddPlaceDetails) {
                let request = {
                    placeId: place.id,
                };

                let service = new google.maps.places.PlacesService(this.dummyRefForGooglePlaceService.current as any);
                service.getDetails(request, this.PlaceDetailsCallback.bind(this));
            } else {
                this.props.OnSelectedPlace(place);
            }
        });

    }

    private RenderPlaceDropDown() {
        if (this.state.PlaceDropDownOpen) {
            return (
                <div className="place-drop-down-container drop-down-container">
                    {this.RenderTabListTitle()}
                    <ul>
                        {this.state.Places.map((item) =>
                            //item.terms
                            <li key={item.id}
                                onClick={this.OnPlaceClick.bind(this, item)}
                                className={this.state.Places.indexOf(item) === this.state.HighLightedIndex ? 'highlighted' : ''}>
                                {item.name}
                            </li>
                        )}
                    </ul>
                    <div><img src="/images/powered_by_google_on_white.png" width="128" height="16" /></div>
                </div>
            );
        } else {
            return null;
        }
    }


    private RenderTabListTitle() {
        if (this.state.Places === this.defaultCities) {
            return (<div className="tab-list-title">najczęstsze</div>);
        } else {
            return null;
        }
    }

    private GetDefaultPlaces() {
        let service = new SearchService();
        service.GetDefaultPlaces(this.OnGetPlacesSuccess, this.OnGetPlacesError);
    }

    private OnGetPlacesSuccess(result) {
        this.defaultCities = result.data.Value;
        this.setState({
            Places: this.defaultCities
        });
    }

    private OnGetPlacesError(error) {
        console.error(error);
    }

    private HandleClickOutside(e: MouseEvent) {
        if (this.placeDropDownContainerNode !== null) {
            if (this.placeDropDownContainerNode.contains(e.target as HTMLElement)) {
                this.setState({
                    PlaceDropDownOpen: true
                });
            } else {
                if ((e.target as HTMLElement).tagName !== 'BUTTON') {
                    this.setState({
                        PlaceDropDownOpen: false
                    });
                }
            }
        }
    }

    private OnInputKeyPress(evt) {
        switch (evt.key) {
            case 'ArrowDown':
                this.setState({
                    HighLightedIndex:
                        this.state.Places.length > 0 ?
                            (this.state.HighLightedIndex + this.state.Places.length + 1) % this.state.Places.length :
                            0
                });
                break;
            case 'ArrowUp':
                this.setState({
                    HighLightedIndex: this.state.Places.length > 0 ?
                        (this.state.HighLightedIndex + this.state.Places.length - 1) % this.state.Places.length :
                        0
                });
                break;
            case 'Escape':
                this.setState({
                    PlaceDropDownOpen: false
                });
                break;
            case 'Enter':
                evt.preventDefault();
                if (this.state.PlaceDropDownOpen) {
                    if (this.state.Places.length > 0 && this.state.HighLightedIndex >= 0 && this.state.HighLightedIndex < this.state.Places.length) {
                        //this.OnPlaceClick(this.state.Places[0]);
                        this.OnPlaceClick(this.state.Places[this.state.HighLightedIndex]);
                    } else {
                        if (this.state.Places.length > 0) {
                            this.OnPlaceClick(this.state.Places[0]);
                        }
                    }
                } else {
                    //null
                }
                break;
        }

    }

    private GetPlaceDetails_GetSelectedPlace(place: IPlace) {
        let request = {
            placeId: place.place_id as string,
            fields: ['geometry']
        };

        this.selectedPlaceFromList = place;
        let service = new google.maps.places.PlacesService(this.dummyRefForGooglePlaceService.current as any);
        service.getDetails(request, this.PlaceDetailsCallback_GetSelectedPlace.bind(this));
    }

    private PlaceDetailsCallback_GetSelectedPlace(
        place: google.maps.places.PlaceResult,
        status: google.maps.places.PlacesServiceStatus
    ) {
        if (status === google.maps.places.PlacesServiceStatus.OK) {

            if (place.geometry !== undefined && this.selectedPlaceFromList !== undefined) {
                let selectedPlace: IPlace = this.selectedPlaceFromList;
                this.selectedPlaceFromList = undefined;
                selectedPlace.location = {
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng()
                };

                if (place.geometry.viewport) {
                    let viewport = place.geometry.viewport;
                    selectedPlace.viewport = {
                        northeast: { lat: viewport.getNorthEast().lat(), lng: viewport.getNorthEast().lng() },
                        southwest: { lat: viewport.getSouthWest().lat(), lng: viewport.getSouthWest().lng() }
                    }
                    selectedPlace.useOnlyViewportForSearch = false;
                }
                this.setState({
                    SelectedPlace: selectedPlace
                });
                this.props.OnPlaceDetailsReceived(selectedPlace);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/Search/PlaceSearch.tsx